import React, { useState, useContext, useEffect } from 'react';
import { Grid, TextField, Checkbox } from '@material-ui/core';
import _ from 'lodash';
import GrowingTable from 'app/components/GrowingTable';
import { Field } from 'formik';
import InputMask from 'react-input-mask';
import { FormServiceContext } from 'app/utils/contexts';
import helpers from 'app/utils/helpers';

function Contact(props) {
  const { errors, touched, values } = props;
  const [phoneMask, setPhoneMask] = useState('(99) 9999-99999');
  const [deTelefone, setDeTelefone] = useState(values.deTelefone?values.deTelefone:'');
  const { isInternalForm, canEdit } = useContext(FormServiceContext);

  const [contacts, setContacts] = useState(() => {
    if (values.contatos) {
      return values.contatos.filter(contact => !contact.peParticipacaoSocietaria && !contact.boExcluido);
    }
    return [];
  });
  const [deletedContacts, setDeletedContacts] = useState(() => {
    if (values.contatosExcluidos) {
      return values.contatosExcluidos;
    }
    return [];
  });
  
  useEffect(() => {
    if (values.contatos && !values.socios) {
      const partners = values.contatos.filter(contact => !!contact.peParticipacaoSocietaria && !contact.boExcluido);
      values.socios = partners;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [tableData, setTableData] = useState({
    columns: [
      {
        title: 'Nome',
        field: 'nmPessoa',
        align: 'center',
        editComponent: props => (
          <TextField
            {...props}
            variant="outlined"
            margin="dense"
            label="Nome*"
            disabled={!canEdit}
            fullWidth
            inputProps={{
              maxLength: 180,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ),
      },
      {
        title: 'Função',
        field: 'deFuncao',
        align: 'center',
        editComponent: props => (
          <TextField
            {...props}
            variant="outlined"
            margin="dense"
            label="Função*"
            disabled={!canEdit}
            fullWidth
            inputProps={{
              maxLength: 90,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ),
      },
      {
        title: 'Telefone Fixo',
        field: 'deTelefoneFixo',
        align: 'center',
        fieldmask:'(99) 9999-9999',
        editComponent: props =>
          canEdit ? (
            <InputMask mask={props.fieldmask} maskChar={' '} disabled={!canEdit} {...props}>
              {() => (
                <TextField
                  {...props}
                  variant="outlined"
                  margin="dense"
                  label="Telefone Fixo"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          ) : (
            <TextField
              {...props}
              variant="outlined"
              margin="dense"
              label="Telefone Fixo"
              disabled={!canEdit}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          ),
      },
      {
        title: 'Telefone Móvel',
        field: 'deTelefoneMovel',
        align: 'center',
        fieldmask:'(99) 99999-9999',
        editComponent: props =>
          canEdit ? (
            <InputMask mask={props.fieldmask} maskChar={' '} {...props}>
              {() => (
                <TextField
                  {...props}
                  variant="outlined"
                  label="Telefone Móvel*"
                  margin="dense"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          ) : (
            <TextField
              {...props}
              variant="outlined"
              label="Telefone Móvel*"
              margin="dense"
              disabled={!canEdit}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          ),
      },
      {
        title: 'Email',
        field: 'deEmail',
        align: 'center',
        editComponent: props => (
          <TextField
            {...props}
            variant="outlined"
            margin="dense"
            label="Email*"
            disabled={!canEdit}
            fullWidth
            inputProps={{
              maxLength: 150,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ),
      },
      {
        title: 'Principal',
        field: 'boPrincipalContato',
        align: 'center',
        editComponent: props => <Checkbox {...props} disabled={!canEdit} />,
      },
    ],
    data: contacts,
  });

  const addContact = contact => {
    setTableData(contact);
    setContacts(contact.data);
    values.contatos = contact.data;
  };

  const onChangeField = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    const checked = e.target.checked;
    const temp = _.cloneDeep(contacts);
    if(!temp[index]['boPrincipalContato']){
      temp[index]['boPrincipalContato'] = false;
    }
    if (name === 'boPrincipalContato') {
      temp.forEach((contact, i) => {
        temp[i]['boPrincipalContato'] = false;
      });
      temp[index][name] = checked;
    } else {
      temp[index][name] = value;
    }
    setContacts(temp);
    values.contatos = temp;
    const tableDt = { ...tableData };
    tableDt.data = temp;
    setTableData(tableDt);
  };

  const changePhone = (e) => {
    const value = e.target.value;
    if(helpers.somenteNumeros(value).length >= 11){
      setPhoneMask('(99) 99999-9999');
    }else{
      setPhoneMask('(99) 9999-99999');
    }
    setDeTelefone(value);
    values.deTelefone = value;
  }

  const changeContact = index => {
    const temp = [...tableData.data];
    if (index === undefined) {
      temp.push({});
    } else {
      if (window.confirm('Deseja excluir este item?')) {
        if(temp[index].cdPessoaEmpresa){
          const t = [...deletedContacts];
          const contact = {...temp[index], boExcluido:true};
          t.push(contact);
          setDeletedContacts(t);
          values.contatosExcluidos = t;
        }
        temp.splice(index, 1);
      }
    }
    addContact({ ...tableData, data: temp });  
  };
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        {canEdit ? (
          <Field name="deTelefone">
            {({ field, form: { errors, values }, meta }) => (
              <InputMask mask={phoneMask} maskChar={' '} {...field} onChange={(e) => changePhone(e)} value={deTelefone}>
                {() => (
                  <TextField
                    {...props}
                    name="deTelefone"
                    label="Telefone*"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    error={!!errors.deTelefone && touched.deTelefone}
                    helperText={errors.deTelefone && touched.deTelefone ? errors.deTelefone : ''}
                  />
                )}
              </InputMask>
            )}
          </Field>
        ) : (
          <TextField
            label="Telefone*"
            value={values.deTelefone}
            variant="filled"
            margin="dense"
            disabled
            fullWidth
          />
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          name="deSite"
          label="Site"
          type="deSite"
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          error={!!errors.deSite && touched.deSite}
          helperText={errors.deSite && touched.deSite ? errors.deSite : ''}
          as={TextField}
          inputProps={{
            maxLength: 45,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          name="deEmail"
          label="E-mail*"
          type="deEmail"
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          error={!!errors.deEmail && touched.deEmail}
          helperText={errors.deEmail && touched.deEmail ? errors.deEmail : ''}
          as={TextField}
          inputProps={{
            maxLength: 90,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <GrowingTable
          title="Contatos"
          tabledata={tableData}
          addtabledata={addContact}
          handlechange={onChangeField}
          customAddElement={changeContact}
          canEdit={canEdit}
          isInternalForm={isInternalForm}
        />
      </Grid>
    </Grid>
  );
}

export default Contact;
